<ngx-datatable
    [rows]="rows"
    [columnMode]="ColumnMode.force"
    [headerHeight]="50"
    [footerHeight]="50"
    rowHeight="auto"
>
    <ngx-datatable-column name="Name">
        <ng-template let-column="column" ngx-datatable-header-template> Holla! {{ column.name }} </ng-template>
        <ng-template let-value="value" ngx-datatable-cell-template>
            Hi: <strong>{{ value }}</strong>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Gender">
        <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
            <span (click)="sort()">{{ column.name }}</span>
        </ng-template>
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            My name is: <i [innerHTML]="row['name']"></i> and <i>{{ value }}</i>
            <div>{{ joke }}</div>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Age">
        <ng-template let-value="value" ngx-datatable-cell-template>
            <div class="progress progress-sm">
                <div class="progress-bar" [style.width]="value + '%'"></div>
            </div>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>